import { CheckCircle, AlertCircle, XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import type { DoulaListing } from "./types";

interface StatusCardProps {
	listing: DoulaListing | null;
	onRemoveListing: () => void;
}

export default function StatusCard({
	listing,
	onRemoveListing,
}: StatusCardProps) {
	const getStatusIcon = (status: string) => {
		switch (status) {
			case "active":
				return <CheckCircle className="h-4 w-4" />;
			case "pending":
				return <AlertCircle className="h-4 w-4" />;
			case "suspended":
				return <XCircle className="h-4 w-4" />;
			default:
				return <AlertCircle className="h-4 w-4" />;
		}
	};

	if (!listing) return null;

	return (
		<Card className="glass-card border-0 shadow-lg mb-8">
			<CardContent className="p-6">
				<div className="bg-white/80 rounded-lg p-4 border border-gray-200 shadow-sm">
					<div className="flex items-center justify-between">
						<div className="flex items-center space-x-4">
							<div
								className={`p-2 rounded-full ${listing.status === "active" ? "bg-newTheme-lime" : listing.status === "pending" ? "bg-newTheme-orange" : "bg-red-100"}`}
							>
								{getStatusIcon(listing.status)}
							</div>
							<div>
								<h3 className="font-semibold text-gray-900 font-karla capitalize">
									{listing.status}
								</h3>
								<p className="text-sm text-gray-600 font-karla">
									{listing.status === "active"
										? "Your profile is live and visible to parents"
										: listing.status === "pending"
											? "Your profile is under review"
											: "Your profile is currently suspended"}
								</p>
							</div>
						</div>
						{listing.status === "active" && (
							<Button
								onClick={onRemoveListing}
								variant="outline"
								className="text-red-600 border-red-300 hover:bg-red-50 hover:text-red-600 shadow-btn-shadow"
							>
								Remove Listing
							</Button>
						)}
					</div>
				</div>
			</CardContent>
		</Card>
	);
}
